import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Badge } from "reactstrap";
import { audienceService } from "../../services/audience.service";
import Moment from "react-moment";
import dayjs from "dayjs";
import { FaPlay } from "react-icons/fa";
import { BiMoviePlay } from "react-icons/bi";
import "./cardMain.scss";

export function CardMain() {
  const [listAudienceO, setListAudienceO] = useState([]);
  const itemsPerPage = 1;

  async function getComplete() {
    audienceService.getLastOrDefault(0, 0, itemsPerPage).then((result) => {
      if (result) setListAudienceO(result);
    });
  }

  useEffect(() => {
    getComplete();
  }, []);

  const hoy = dayjs();

  return (
    <>
      {listAudienceO.map((item, index) => {
        //TODO LAGG: cambiar el link pasando como parámetro el Id para abrir el video
        return (
          <div className="itemcard_post_muro pridetalks" key={index}>
            <div className="container-page">
              <h3 className="ttls_big_muro font_ttl_in_home">NUEVO EPISODIO</h3>
              <div className="itemcard_content">
                <div className="itemcard_content_picture">
                  <img
                    src={item.files && item.files[0]?.path}
                    alt={item.data.title}
                    title={item.data.title}
                  />
                </div>

                <div className="itemcard_content_info">
                  <div className="tag">
                    <Badge className="badge t_g ">
                      {hoy > dayjs(item.data.conferenceDate)
                        ? "Pride Talks"
                        : "Próximamente"}
                    </Badge>
                  </div>
                  <h6 className="itemcard_content_title font_ttl_in_home">
                    {item.data.title.length <= 50
                      ? item.data.title
                      : `${item.data.title.substring(0, 50)}...`}
                    {/* {item.data.title} */}
                  </h6>
                  <p className="itemitemcard_content_description">
                    <Moment
                      date={item.data.conferenceDate}
                      format="dddd DD [de] MMMM [del] YYYY"
                    ></Moment>
                  </p>
                  <div className="actions_itemcard">
                    <Link
                      to={
                        hoy > dayjs(item.data.conferenceDate)
                          ? `/audience/${item.data.auditoriumId}`
                          : "/audience"
                      }
                      className="btn___home"
                      key={item.data.auditoriumId}
                    >
                      <span>Dale play</span> <FaPlay />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
}
